const linkedInPosterEnglish = {
  messages: {
    connectionError: "An error occurred while checking your connections",
    codeGenerationError: "An error occurred while generating the connection code. Please try again later.",
    workflowTestSuccess: "LinkedIn post sent via Telegram! Check your Telegram chat.",
    workflowTestError: "Error testing workflow. Check the console for details.",
    linkedInDisconnectError: "An error occurred while disconnecting LinkedIn: {message}",
    telegramDisconnectError: "An error occurred while disconnecting Telegram: {message}",
    deliveryPreferenceError: "An error occurred while setting delivery preference: {message}"
  }
};

export default linkedInPosterEnglish; 